import React from 'react';
import { Typography, styled } from '@nextiva/next-ui-components';

const StyledContainer = styled('div')`
  margin-top: 16px;
`;
const StyledLink = styled('a')`
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: underline;
`;

const TERMS_AND_CONDITIONS_LINK = 'https://www.nextiva.com/legal.html';

export const TermsAndConditions = () => (
  <StyledContainer>
    <Typography
      variant="caption"
      data-testid="PlatformAdminUI-PurchaseLicenseModal-TermsAndConditionsText"
    >
      By clicking ‘Pay’, you acknowledge and agree that the additional services
      are subject to{' '}
      <StyledLink
        href={TERMS_AND_CONDITIONS_LINK}
        rel="noreferrer"
        target="_blank"
        data-testid="PlatformAdminUI-PurchaseLicenseModal-TermsAndConditionsLink"
      >
        Nextiva&apos;s Terms and Conditions
      </StyledLink>{' '}
      and any term service agreement between you and Nextiva. Your plan will
      renew automatically by charging your payment method on file. *The amounts
      are estimated and may change due to taxes, fees and other surcharges.
    </Typography>
  </StyledContainer>
);
